import React from "react";
import { ArrowUpRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import { CtaBand } from "@/pages/Home";
import { INSIGHTS } from "@/data/site";

export default function Insights() {
  const [feature, ...rest] = INSIGHTS;

  return (
    <div data-testid="insights-page">
      <PageHero
        overline="Insights"
        title="Market structure, from the desk."
        subtitle="Plain-English explainers on liquidity, market structure and the wholesale AFSL framework. General information for wholesale audiences — not financial product advice, and not commentary on any price or instrument."
      />

      {/* FEATURE */}
      <section className="py-24 md:py-28 relative z-10" data-testid="insight-feature">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <article className="group border border-white/10 bg-[#11151C]/50 hover:border-[#C8A45A]/40 transition-colors p-10 md:p-14" data-testid={`insight-feature-${feature.id}`}>
              <div className="flex items-center gap-3 text-xs">
                <span className="text-[#C8A45A] font-mono uppercase tracking-widest">{feature.category}</span>
                <span className="text-[#737882]">·</span>
                <span className="text-[#737882]">{feature.date}</span>
                <span className="text-[#737882]">·</span>
                <span className="text-[#737882]">{feature.read}</span>
              </div>
              <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-light text-white mt-6 leading-tight max-w-3xl group-hover:text-[#C8A45A] transition-colors">
                {feature.title}
              </h2>
              <p className="text-[#A1A5AB] mt-6 leading-relaxed max-w-2xl text-lg">{feature.excerpt}</p>
              <span className="inline-flex items-center gap-2 text-[#C8A45A] mt-8 text-sm tracking-wide link-underline">
                Read article <ArrowUpRight size={16} />
              </span>
            </article>
          </Reveal>
        </div>
      </section>

      {/* LIST */}
      <section className="pb-24 md:pb-32 relative z-10" data-testid="insight-list">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10">
            {rest.map((post, i) => (
              <Reveal key={post.id} delay={i * 0.08} className="bg-[#0A0D12]">
                <article className="group p-10 h-full hover:bg-[#11151C] transition-colors" data-testid={`insight-item-${post.id}`}>
                  <div className="flex items-center gap-3 text-xs">
                    <span className="text-[#C8A45A] font-mono uppercase tracking-widest">{post.category}</span>
                    <span className="text-[#737882]">·</span>
                    <span className="text-[#737882]">{post.date}</span>
                  </div>
                  <h3 className="font-display text-2xl text-white mt-6 leading-snug group-hover:text-[#C8A45A] transition-colors">
                    {post.title}
                  </h3>
                  <p className="text-[#A1A5AB] mt-4 leading-relaxed">{post.excerpt}</p>
                  <div className="mt-6 flex items-center justify-between">
                    <span className="text-xs text-[#737882]">{post.read}</span>
                    <ArrowUpRight size={18} className="text-[#737882] group-hover:text-[#C8A45A] transition-colors" />
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.1}>
            <p className="text-sm text-[#737882] mt-10 font-mono">More research published regularly. Contact us to join the distribution list.</p>
          </Reveal>
        </div>
      </section>

      <CtaBand />
    </div>
  );
}
